import { useEffect } from 'react';
import { track } from '../lib/analytics';

// Fires scroll_depth at 25/50/75/100% and read_complete once per page key.
export const useScrollDepth = (key, params = {}) => {
  useEffect(() => {
    if (!key || typeof window === 'undefined') return undefined;
    const fired = new Set();
    const onScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      const pct = Math.round((window.scrollY / max) * 100);
      [25, 50, 75, 100].forEach((m) => {
        if (pct >= m && !fired.has(m)) {
          fired.add(m);
          track('scroll_depth', { percent: m, label: key, ...params });
          if (m === 100) track('read_complete', { label: key, ...params });
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
};
